import { render, staticRenderFns } from "./TenantPaymentsCard.vue?vue&type=template&id=4fe21c3a&scoped=true&"
import script from "./TenantPaymentsCard.vue?vue&type=script&lang=js&"
export * from "./TenantPaymentsCard.vue?vue&type=script&lang=js&"
import style0 from "./TenantPaymentsCard.vue?vue&type=style&index=0&id=4fe21c3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe21c3a",
  null
  
)

export default component.exports